/* eslint-disable no-type-assertion/no-type-assertion -- lint to the future batch ignore */
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { APP_STORE_BADGE_ASSETS } from 'register-partners-js/constants/store-badge-assets';

type AppStoreBadgeProps = ComponentPropsWithoutRef<'a'>;

const APP_STORE_ID = '1214811644';

export function AppStoreBadge(props: AppStoreBadgeProps): ReactNode {
  const { locale } = useIntl();

  const appStoreLocale = locale === 'en' ? 'us' : locale;
  const badgeSrc = APP_STORE_BADGE_ASSETS[locale as keyof typeof APP_STORE_BADGE_ASSETS];

  const appStoreUrl = `https://apps.apple.com/${appStoreLocale}/app/qonto-business-finance-app/id${APP_STORE_ID}`;

  return (
    <a data-test-app-store-link href={appStoreUrl} {...props}>
      <img alt="" role="presentation" src={badgeSrc} />
    </a>
  );
}
